import React from 'react'
import { Image } from '@shared/components/image'
import cn from 'classnames'
import { useMedia } from 'use-media'

import { Back } from '../Back'

import styles from './styles.module.scss'

const InvestCC = () => {
	const isTablet = useMedia({ minWidth: '678px' })

	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Сбережения через Credit.Club</h1>

			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#how-it-works'>
							Принцип работы
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#programs'>
							Программы
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#profit'>
							Доходность
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#replenishment-amount'>
							Сумма для пополнения
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#close-earlier'>
							Досрочный вывод
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#referral'>
							Реферальная программа
						</a>
					</li>
				</ul>
			</nav>

			<h3 id='how-it-works' className={styles.title}>
				Принцип работы
			</h3>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Работают сбережения так:</p>

			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>
					Сначала пайщик — человек, который хочет сделать сбережение, — вносит деньги на
					определенный срок в КПК «Фонд Ипотечного Кредитования».
				</li>
				<li className={styles.orderedItem}>
					Деньги попадают в специальный фонд. Из него кооператив через платформу цифрвых решений
					Credit.Club выдаёт займы другим пайщикам кооператива, которые проходят многоэтапную
					проверку.
				</li>
				<li className={styles.orderedItem}>
					Заёмщики КПК возвращают деньги, а сберегатель получает фиксированный доход, который не
					зависит от ежемесячных выплат по займам.
				</li>
			</ol>

			<h3 id='programs' className={styles.title}>
				Программы
			</h3>
			<p className={styles.paragraph}>
				Начать лучше всего с программы «Первое сбережение». Она рассчитана на то, чтобы сберегатель
				мог оценить продукт за оптимальный срок и при этом получать высокую доходность ежемесячно на
				счёт. Если ему срочно понадобятся деньги, их можно вывести в любой момент без потери
				процентов.
			</p>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Условия программы «Первое сбережение»:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>— минимальная сумма инвестиции — 300 тысяч рублей;</li>
				<li className={styles.item}>— срок размещения денег — 6 месяцев;</li>
				<li className={styles.item}>— выплаты — ежемесячно.</li>
			</ul>
			<p className={styles.paragraph}>
				По отдельным программам можно разместить сбережения на 12 и 24 месяцев.
			</p>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Подробнее о программах сбережений можно уточнить у менеджера. В личном кабинете инвестора
				можно заказать обратный звонок или связаться с ним любым удобным способом:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>— телефон или WhatsApp: +7 921 447-98-18;</li>
				<li className={styles.item}>— почта: p.kuligin@credit.club.</li>
			</ul>
			<Image
				name={isTablet ? 'consult-t.jpg' : 'consult-m.png'}
				alt='скриншот получения консультации'
			/>

			<h3 id='profit' className={styles.title}>
				Доходность
			</h3>
			<p className={styles.paragraph}>
				Доходность сбережений складывается из выплат от КПК и бонуса от платформы цифровых решений
				Credit.Club.
			</p>
			<p className={styles.paragraph}>
				Максимальная ставка по выплатам в КПК равна удвоенному значению ключевой ставки Центробанка.
			</p>
			<p className={styles.paragraph}>
				Вторая часть доходности — это выплаты от платформы Credit.Club. Они приносят дополнительные
				проценты к прибыли. Проценты зависят от срока вложения денег и условий программы.
			</p>

			<h3 id='replenishment-amount' className={styles.title}>
				Сумма для пополнения
			</h3>
			<p className={styles.paragraph}>
				Пополнить сбережения можно неограниченное число раз на сумму от 20 тысяч за один перевод.
			</p>

			<h3 id='close-earlier' className={styles.title}>
				Досрочный вывод
			</h3>
			<p className={styles.paragraph}>
				Всё зависит от выбранной программы сбережений. Некоторые из них позволяют вывести деньги
				досрочно без потери доходности. Для этого нужно обратиться к менеджеру, запросить шаблон
				заявления на досрочный вывод денег и подписать его через электронную подпись.
			</p>

			<h3 id='referral' className={styles.title}>
				Реферальная программа
			</h3>
			<p className={styles.paragraph}>
				Рекомендуйте нас своим родным и знакомым, чтобы дополнительно зарабатывать на сбережениях.
			</p>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Условия реферальной программы:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>
					— вознаграждение — 1% от суммы сбережения привлеченного друга;
				</li>
				<li className={styles.item}>— максимальный срок выплат — 12 месяцев;</li>
				<li className={styles.item}>— выплаты — ежемесячно.</li>
			</ul>

			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Как воспользоваться:</p>
			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>Зайти в «Профиль» в личном кабинете инвестора.</li>
				<li className={styles.orderedItem}>Скопировать персональную ссылку.</li>
				<li className={styles.orderedItem}>Отправьте друзьям и знакомым.</li>
			</ol>

			<Image
				name={isTablet ? 'profile-t.jpg' : 'profile-m.png'}
				alt='скриншот получения консультации'
			/>
		</article>
	)
}

export default InvestCC
